import api from "./api";

export const fetchDashboardSummary = async () => {
  try {
    const response = await api.get("/dashboard/summary");

    console.log("Dashboard summary:", response.data);

    return response.data; 
    // {
    //   metrics: { ... },
    //   recent_verifications: [ ... ]
    // }
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to load dashboard summary";
  }
};


export const fetchCertificates = async () => {
  try {
    const response = await api.get("/certificate/certificates");

    console.log("Certificates response:", response.data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch certificates";
  }
};


export const importCertificatesCsv = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
      "/certificate/certificates/import",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("Import API Response:", response.data);

    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "CSV import failed";
  }
};


export const issueCertificate = async (payload: any) => {
  try {
    const response = await api.post("/certificate/create", payload);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to issue certificate";
  }
};


export const editCertificate = async (certId: string | number, payload: any) => {
  try {
    const response = await api.put(`/certificate/certificates/${certId}`, payload);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to edit certificate";
  }
};


export const deleteCertificate = async (certId: string | number) => {
  try {
    const response = await api.delete(`/certificate/certificates/${certId}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to delete certificate";
  }
};